import { BaseFetch } from "../main-model"
export default class ReportOnetModel extends BaseFetch {
    getReportOnetBy = (data) =>
    this.authFetch({
      url: "report-onet/getReportOnetBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportOnetAVGBy = (data) =>
    this.authFetch({
      url: "report-onet/getReportOnetAVGBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}